/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Head_Catalog_DescriptionInputs */

const en_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Browse every API we serve, with measured latency and uptime on each. ${i?.count} APIs across social, SEO, enrichment, and e-commerce.`)
};

const zh_hans1_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`浏览我们提供的所有 API，每个都附有实测延迟和可用率。${i?.count} 个 API，覆盖社交、SEO、数据补全和电商。`)
};

const pt_br2_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veja todas as APIs que oferecemos, com latência e disponibilidade medidas em cada uma. São ${i?.count} APIs de redes sociais, SEO, enriquecimento e e-commerce.`)
};

const es_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explora todas las APIs que ofrecemos, con la latencia y la disponibilidad medidas de cada una. ${i?.count} APIs de redes sociales, SEO, enriquecimiento y comercio electrónico.`)
};

const fr_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parcourez chaque API que nous servons, avec la latence et la disponibilité mesurées pour chacune. ${i?.count} API couvrant les réseaux sociaux, le SEO, l’enrichissement et l’e-commerce.`)
};

const de_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stöbere in jeder API, die wir anbieten, mit gemessener Latenz und Verfügbarkeit bei jeder. ${i?.count} APIs für Social, SEO, Datenanreicherung und E-Commerce.`)
};

const ru_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Все API, которые мы предоставляем, с измеренной задержкой и доступностью по каждому. API в количестве ${i?.count}: соцсети, SEO, обогащение данных и электронная коммерция.`)
};

const it_head_catalog_description = /** @type {(inputs: Head_Catalog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sfoglia ogni API che serviamo, con latenza e disponibilità misurate per ciascuna. ${i?.count} API tra social, SEO, arricchimento ed e-commerce.`)
};

/**
* | output |
* | --- |
* | "Browse every API we serve, with measured latency and uptime on each. {count} APIs across social, SEO, enrichment, and e-commerce." |
*
* @param {Head_Catalog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const head_catalog_description = /** @type {((inputs: Head_Catalog_DescriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Head_Catalog_DescriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_head_catalog_description(inputs)
	if (locale === "pt-BR") return pt_br2_head_catalog_description(inputs)
	if (locale === "es") return es_head_catalog_description(inputs)
	if (locale === "fr") return fr_head_catalog_description(inputs)
	if (locale === "de") return de_head_catalog_description(inputs)
	if (locale === "ru") return ru_head_catalog_description(inputs)
	if (locale === "it") return it_head_catalog_description(inputs)
	return en_head_catalog_description(inputs)
});